"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.today = void 0;
var fdate_1 = require("./fdate");
/**
 * dzisiejsza data w formacie yyyy-MM-dd
 */
function today() {
    return (0, fdate_1.default)(new Date());
}
exports.today = today;
exports.default = today;
//# sourceMappingURL=today.js.map